import { render, staticRenderFns } from "./image-gallery.vue?vue&type=template&id=5bba4c12&scoped=true"
import script from "./image-gallery.vue?vue&type=script&lang=js"
export * from "./image-gallery.vue?vue&type=script&lang=js"
import style0 from "./image-gallery.vue?vue&type=style&index=0&id=5bba4c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba4c12",
  null
  
)

export default component.exports